export enum SmartAdType {
  BANDEROLE = 'BANDEROLE',
  RECTANGLE = 'RECTANGLE',
}
